module.exports = __webpack_public_path__ + "media/1345CommonSpace.f4892ed3.webm";